"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CalendarDatasService", {
    enumerable: true,
    get: function() {
        return CalendarDatasService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _datasservice = require("~/services/datas.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let CalendarDatasService = class CalendarDatasService {
    async getCalendarDataList(context, param) {
        var _calendarRange_ranges;
        const { viewId, query, from_date, to_date, next_date, prev_date } = param;
        if (!from_date || !to_date || !next_date || !prev_date) _catchError.NcError.get(context).badRequest('from_date and to_date are required');
        if ((0, _dayjs.default)(to_date).diff((0, _dayjs.default)(from_date), 'days') > 42) {
            _catchError.NcError.get(context).badRequest('Date range should not exceed 42 days');
        }
        const view = await _models.View.get(context, viewId);
        if (!view) _catchError.NcError.get(context).viewNotFound(viewId);
        if (view.type !== _nocodbsdk.ViewTypes.CALENDAR) _catchError.NcError.get(context).badRequest('View is not a calendar view');
        const calendarRange = await _models.CalendarRange.read(context, view.id);
        if (!(calendarRange == null ? void 0 : (_calendarRange_ranges = calendarRange.ranges) == null ? void 0 : _calendarRange_ranges.length)) _catchError.NcError.get(context).badRequest('No ranges found');
        const colId = calendarRange.ranges[0].fk_from_column_id;
        let isDate = false;
        if (colId) {
            const column = await _models.Column.get(context, {
                colId
            });
            if (!column) _catchError.NcError.get(context).badRequest('Invalid column for calendar view');
            isDate = column.uidt === _nocodbsdk.UITypes.Date;
        }
        const filterArr = await this.buildFilterArr(context, {
            viewId,
            from_date,
            to_date,
            next_date,
            prev_date,
            isDate
        });
        query.filterArrJson = JSON.stringify([
            ...filterArr,
            ...query.filterArrJson ? JSON.parse(query.filterArrJson) : []
        ]);
        const model = await _models.Model.getByIdOrName(context, {
            id: view.fk_model_id
        });
        return await this.datasService.dataList(context, _extends({}, param, query, {
            viewName: view.id,
            baseName: model.base_id,
            tableName: model.id,
            limitOverride: 3000
        }));
    }
    async getPublicCalendarRecordCount(context, param) {
        const { sharedViewUuid, password, query = {} } = param;
        const view = await _models.View.getByUUID(context, sharedViewUuid);
        if (!view) _catchError.NcError.get(context).viewNotFound(sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.get(context).notFound('View is not a calendar view');
        }
        if (!await _models.View.verifyPassword(view, password)) {
            return _catchError.NcError.get(context).invalidSharedViewPassword();
        }
        return this.getCalendarRecordCount(context, {
            viewId: view.id,
            query,
            from_date: param.from_date,
            to_date: param.to_date,
            next_date: param.next_date,
            prev_date: param.prev_date
        });
    }
    async getPublicCalendarDataList(context, param) {
        const { sharedViewUuid, password, query = {} } = param;
        const view = await _models.View.getByUUID(context, sharedViewUuid);
        if (!view) _catchError.NcError.get(context).viewNotFound(sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.get(context).notFound('View is not a calendar view');
        }
        if (!await _models.View.verifyPassword(view, password)) {
            return _catchError.NcError.get(context).invalidSharedViewPassword();
        }
        return this.getCalendarDataList(context, {
            viewId: view.id,
            query,
            from_date: param.from_date,
            to_date: param.to_date,
            next_date: param.next_date,
            prev_date: param.prev_date
        });
    }
    async getCalendarRecordCount(context, param) {
        var _ranges_ranges;
        const { viewId, query, from_date, to_date, next_date, prev_date } = param;
        if (!from_date || !to_date || !next_date || !prev_date) _catchError.NcError.get(context).badRequest('from_date and to_date are required');
        if ((0, _dayjs.default)(to_date).diff((0, _dayjs.default)(from_date), 'days') > 395) {
            _catchError.NcError.get(context).badRequest('Date range should not exceed 395 days');
        }
        const view = await _models.View.get(context, viewId);
        if (!view) _catchError.NcError.get(context).viewNotFound(viewId);
        if (view.type !== _nocodbsdk.ViewTypes.CALENDAR) _catchError.NcError.get(context).badRequest('View is not a calendar view');
        const ranges = await _models.CalendarRange.read(context, view.id);
        if (!(ranges == null ? void 0 : ranges.ranges.length)) _catchError.NcError.get(context).badRequest('No ranges found');
        const colId = ranges.ranges[0].fk_from_column_id;
        let isDate = false;
        if (colId) {
            const column = await _models.Column.get(context, {
                colId
            });
            if (!column) _catchError.NcError.get(context).badRequest('Invalid column for calendar view');
            isDate = column.uidt === _nocodbsdk.UITypes.Date;
        }
        const filterArr = await this.buildFilterArr(context, {
            viewId,
            from_date,
            to_date,
            next_date,
            prev_date,
            isDate
        });
        query.filterArrJson = JSON.stringify([
            ...filterArr,
            ...query.filterArrJson ? JSON.parse(query.filterArrJson) : []
        ]);
        const model = await _models.Model.getByIdOrName(context, {
            id: view.fk_model_id
        });
        const data = await this.datasService.dataList(context, _extends({}, param, {
            baseName: model.base_id,
            tableName: model.id,
            ignorePagination: true
        }));
        if (!data) _catchError.NcError.get(context).notFound('Data not found');
        const dates = [];
        const columns = await model.getColumns(context);
        ranges == null ? void 0 : (_ranges_ranges = ranges.ranges) == null ? void 0 : _ranges_ranges.forEach((range)=>{
            var _columns_find;
            const fromCol = (_columns_find = columns.find((c)=>c.id === range.fk_from_column_id)) == null ? void 0 : _columns_find.title;
            data.list.forEach((date)=>{
                const fromDt = (0, _dayjs.default)(date[fromCol]);
                if (fromCol && fromDt.isValid()) {
                    dates.push(fromDt.format('YYYY-MM-DD HH:mm:ssZ'));
                }
            });
        });
        return {
            count: dates.length,
            dates: Array.from(new Set(dates))
        };
    }
    async buildFilterArr(context, { viewId, next_date, prev_date, isDate }) {
        var _calendarRange_ranges;
        const calendarRange = await _models.CalendarRange.read(context, viewId);
        if (!(calendarRange == null ? void 0 : (_calendarRange_ranges = calendarRange.ranges) == null ? void 0 : _calendarRange_ranges.length)) _catchError.NcError.get(context).badRequest('No ranges found');
        const filterArr = {
            is_group: true,
            logical_op: 'and',
            children: []
        };
        if (isDate) {
            var _next_date_match, _prev_date_match;
            const regex = /^\d{4}-\d{2}-\d{2}/;
            next_date = ((_next_date_match = next_date.match(regex)) == null ? void 0 : _next_date_match[0]) || next_date;
            prev_date = ((_prev_date_match = prev_date.match(regex)) == null ? void 0 : _prev_date_match[0]) || prev_date;
        }
        calendarRange == null ? void 0 : calendarRange.ranges.forEach((range)=>{
            const fromColumn = range.fk_from_column_id;
            let rangeFilter = [];
            if (fromColumn) {
                rangeFilter = [
                    {
                        fk_column_id: fromColumn,
                        comparison_op: 'lt',
                        comparison_sub_op: 'exactDate',
                        value: next_date
                    },
                    {
                        fk_column_id: fromColumn,
                        comparison_op: 'gte',
                        comparison_sub_op: 'exactDate',
                        value: prev_date
                    }
                ];
            }
            if (rangeFilter.length > 0) filterArr.children.push(rangeFilter);
        });
        return [
            filterArr
        ];
    }
    constructor(datasService){
        this.datasService = datasService;
        this.logger = new _common.Logger(CalendarDatasService.name);
    }
};
CalendarDatasService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService
    ])
], CalendarDatasService);
